// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>
import { path } from "static-path"

export const rootPath = path("/")
export const loginPath = path("/login")
export const credentialsLoginPath = path("/login/credentials")
export const detailsPath = path("/details")
export const profileEditPath = path("/profile/edit")
export const internalAdminDashboardPath = path("/internal-admin/dashboard")
export const internalAdminContactMessagesPath = path("/internal-admin/contact-messages")
export const internalAdminPuzzlesPath = path("/internal-admin/puzzles")
export const internalAdminLogsPath = path("/internal-admin/logs")
export const emailAuthPath = path("/auth/email/:email/:token/:clientAuthCode")
export const puzzleTrackingPath = path("/p/:wpId")
export const userPublicProfilePath = path("/u/:userId")
export const logJourneyPath = path("/p/:wpId/log")
export const journeyLogEditPath = path("/journey-logs/:id/edit")
export const registerPuzzlePath = path("/puzzles/new")
export const puzzleLabelPath = path("/puzzles/:wpId/label")
export const dashboardPath = path("/dashboard")
export const contactPath = path("/contact")
export const aboutPath = path("/about")
export const faqPath = path("/faq")
